import { render, staticRenderFns } from "./SubmitUpdates.vue?vue&type=template&id=f0fac9b8"
import script from "./SubmitUpdates.vue?vue&type=script&lang=js"
export * from "./SubmitUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports